import { connect } from 'react-redux';

import PopUpManager from './PopUpManager';

const mapStateToProps = state => ({
	popUp: state.popUp,
});

export default connect(mapStateToProps)(PopUpManager);
